module.exports = __webpack_public_path__ + "img/logo.c626d61e.png";